import { createSlice } from "@reduxjs/toolkit";

//const token = storage.get("classToken") || "";

const initialState = {
  bookFields: {
    materialTypes: ["Textbook", "Research Article", "Media Article", "Other"],
    languages: ["English", "Arabic", "French", "Latin"],
    licenses: [
      {
        label: "CC BY",
        img_url: "/assets/images/license_1.svg",
        linkTo: "https://creativecommons.org/licenses/by/4.0/",
      },
      {
        label: "CC BY-SA",
        img_url: "/assets/images/license_1.svg",
        img_url2: "/assets/images/license_2.svg",
        linkTo: "https://creativecommons.org/licenses/by-sa/4.0/",
      },
      {
        label: "CC BY-NC",
        img_url: "/assets/images/license_1.svg",
        img_url2: "/assets/images/license_3.svg",
        linkTo: "https://creativecommons.org/licenses/by-nc/4.0/",
      },
      {
        label: "CC BY-NC-SA",
        img_url: "/assets/images/license_1.svg",
        img_url2: "/assets/images/license_3.svg",
        img_url3: "/assets/images/license_2.svg",
        linkTo: "https://creativecommons.org/licenses/by-nc-sa/4.0/",
      },
      {
        label: "CC BY-ND",
        img_url: "/assets/images/license_1.svg",
        img_url2: "/assets/images/license_4.svg",
        linkTo: "https://creativecommons.org/licenses/by-nd/4.0/",
      },
      {
        label: "CC BY-NC-ND",
        img_url: "/assets/images/license_1.svg",
        img_url2: "/assets/images/license_3.svg",
        img_url3: "/assets/images/license_4.svg",
        linkTo: "https://creativecommons.org/licenses/by-nc-nd/4.0/",
      },
      {
        label: "CC0",
        img_url: "/assets/images/license_5.svg",
        linkTo: "https://creativecommons.org/publicdomain/zero/1.0/",
      },
    ],
    categories: [
      "Arts",
      "Business",
      "Education",
      "Engineering",
      "Healthcare",
      "Humanities",
      "Journalism, Media Studies & Communications",
      "Law",
      "Natural Sciences",
      "Science and Technology",
    ],
  },
};

const slice = createSlice({
  name: "bookFields",
  initialState,

  reducers: {},
});

export const {} = slice.actions;
export default slice.reducer;
